<template>
	<div class="conunctions-info" v-if="horoscope.criteria">
		<div class="conjunctions-table-area">
			<table class="conjunctions-table" width="100%" border="0">
				<thead>
					<tr>
						<th colspan="2">Conjunctions</th>
					</tr>
				</thead>
				<tbody>
				<tr v-for="planet in horoscope.planets.planets" :key="planet.name">
					<template v-if="planet.planetAttributes.inConjunction">
					<td align="left" width="20%"><b>{{planet.name}}</b></td>
					<td align="left">{{planet.planetAttributes.formattedConjunctions}}</td>	
					</template>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		horoscope : {
			type: Object
		}
	},
	data() {
		return {
		}
	},
	mounted() {

	},
	methods: {
	}
}
</script>

<style scoped>

.conunctions-info {
	border: 0px solid;
	display:flex;
	flex-direction: column;
	align-items: center;
	width:100%;
}

.conjunctions-table-area {
	width: 100%;
}

.conjunctions-table {
    border-collapse: collapse;
    margin: 5px 0;
    font-size: 0.9em;
    font-family: sans-serif;
    border-radius: 5px;
 }

.conjunctions-table thead tr {
    background-color: #ACD8AA;
    color: #344E41;
    text-align: left;
    font-weight: bold;
}

.conjunctions-table th {
    padding: 12px 15px;
	font-size: 20px;
}

.conjunctions-table td {
    padding: 12px 15px;
    color: #344E41;
}

.conjunctions-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

</style>
